function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "130");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1820.000000, -1060.000000)",
  id: "Group-2-Copy-10"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1620.000000, 40.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy-4",
  transform: "translate(180.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: 130,
  transform: "translate(20.000000, 1020.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-56",
  x: 0,
  y: 1.13686838e-13,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "attach_file_FILL0_wght600_GRAD0_opsz24",
  transform: "translate(4.000000, 0.000000)",
  fill: "#B1C3CC",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.025,19.175 C4.34166667,19.175 2.91666667,18.5916667 1.75,17.425 C0.583333333,16.2583333 0,14.8333333 0,13.15 L0,4.45 C0,3.21666667 0.429333333,2.16666667 1.288,1.3 C2.146,0.433333333 3.18333333,0 4.4,0 C5.63333333,0 6.68333333,0.433333333 7.55,1.3 C8.41666667,2.16666667 8.85,3.21666667 8.85,4.45 L8.85,12.025 C8.85,12.825 8.575,13.4956667 8.025,14.037 C7.475,14.579 6.80833333,14.85 6.025,14.85 C5.24166667,14.85 4.575,14.579 4.025,14.037 C3.475,13.4956667 3.2,12.825 3.2,12.025 L3.2,4.45 L5.15,4.45 L5.15,12.025 C5.15,12.2916667 5.23333333,12.5126667 5.4,12.688 C5.56666667,12.8626667 5.775,12.95 6.025,12.95 C6.275,12.95 6.48333333,12.8626667 6.65,12.688 C6.81666667,12.5126667 6.9,12.2916667 6.9,12.025 L6.9,4.45 C6.9,3.75 6.65833333,3.15833333 6.175,2.675 C5.69166667,2.19166667 5.1,1.95 4.4,1.95 C3.7,1.95 3.10833333,2.19166667 2.625,2.675 C2.14166667,3.15833333 1.9,3.75 1.9,4.45 L1.9,13.15 C1.9,14.2833333 2.30433333,15.2543333 3.113,16.063 C3.921,16.871 4.89166667,17.275 6.025,17.275 C7.15833333,17.275 8.12933333,16.871 8.938,16.063 C9.746,15.2543333 10.15,14.2833333 10.15,13.15 L10.15,4.45 L12.05,4.45 L12.05,13.15 C12.05,14.8333333 11.4666667,16.2583333 10.3,17.425 C9.13333333,18.5916667 7.70833333,19.175 6.025,19.175 Z",
  id: "Path"
})))))));

var SvgClip = function SvgClip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clip.cc5bdde3.svg";
export { ForwardRef as ReactComponent };